import { RecordBuilder } from "slotworks/server/builders/record-builder";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { SpinResponseSchema, FreespinUpdate } from "slotworks/integration/revolver/schema/spin-record-schema";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import BuyoutRecord from "integration/records/buyout-record";

class BuyoutRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;
        let buyout: boolean;

        if (data && data.data) {
            spinResponse = data.data as SpinResponseSchema;
            if(spinResponse && spinResponse.RESULTS && spinResponse.RESULTS.state &&
                    spinResponse.RESULTS.state.game && spinResponse.RESULTS.state.game == "BUYOUT")
                buyout = true;
        }
        return spinResponse && spinResponse.RESULTS !== undefined && buyout;
                
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let buyoutResponse: BuyoutResponseSchema;

        if (data && data.data) {
            buyoutResponse = data.data as BuyoutResponseSchema;
        }

        const record = new BuyoutRecord();
        
        if(revolverModel.isFreespin(buyoutResponse.RESULTS.next_game)) {
            record.freespinsTriggered = true;    

            if(buyoutResponse.RESULTS.next_game_state) {
                record.freespinsWon = buyoutResponse.RESULTS.next_game_state.total;
            }
        }

        record.totalBetCredits = buyoutResponse.RESULTS.total_bet_cash;
        record.totalCreditsWon = buyoutResponse.RESULTS.total_win_cash;

        return [ record ];
    }
}

export default new BuyoutRecordBuilder();

interface BuyoutResponseSchema {
    RESULTS: Results;
}

interface Results {
    additionalData: any;
    balance: number;
    balance_after_bet: number;
    eval: Eval;
    freeSpinsCount: number;
    game: string;
    gameData: GameData;
    next_game: string;
    next_game_state: NextGameState;
    persisted_progress: any;
    round_id: number;
    state: State;
    total_bet_cash: number;
    total_win_cash: number;
    updated_free_spin_campaign_details: FreespinUpdate;
}

interface Eval {
    gameData: GameData;
}

interface State {
    game: string;
    rounds: number;
    is_complete: true;
}

interface GameData {
    buyoutCost: number;
}

interface NextGameState {
    game: string;
    spins: number;
    total: number; 
    remain: number; 
    rounds: number; 
    retriggers: number;
    is_complete: boolean;
}
